import React from "react";
import { donateCardsData } from "../../../../assets/data/donateData";
import styled from "styled-components";
import { DonateCard } from "../../../index";

export default function index() {
	const { firstCard, secondCard, thirdCard, fourthCard, fifthCard } =
		donateCardsData;

	return (
		<section>
			<Container>
				<div className="wrapper">
					<DonateCard data={firstCard} />
					<DonateCard data={secondCard} />
					<DonateCard data={fifthCard} />
				</div>
				<div className="wrapper">
					<DonateCard data={thirdCard} />
					<DonateCard data={fourthCard} />
				</div>
			</Container>
		</section>
	);
}

const Container = styled.div`
	display: flex;
	justify-content: center;

	.wrapper {
		display: flex;
		flex-direction: column;
		margin-bottom: 3.5rem;
		margin-right: 1.2rem;

		&:last-child {
			margin-top: 3.5rem;
			margin-left: 1.2rem;

			div:last-child {
				margin-bottom: 0 !important;
			}
		}
	}

	@media (max-width: 720px) {
		flex-direction: column;

		.wrapper {
			display: flex;
			flex-direction: column;
			margin-bottom: 0;
			margin-right: 0;

			&:last-child {
				margin-top: 0;
				margin-left: 0;
			}
		}
	}
`;
